import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const COPY =
    "VibeCity brings founders and business owners together in the world's most ambitious cities to build, grow, and run businesses with AI.";

const FILLED = "#F7F4DA";
const UNFILLED = "#666666";

export default function FillCopy() {
    const sectionRef = useRef(null);
    const textRef = useRef(null);
    const wordsRef = useRef([]);

    const words = COPY.split(" ");

    useLayoutEffect(() => {
        const section = sectionRef.current;
        const textEl = textRef.current;
        if (!section || !textEl) return;

        const targets = wordsRef.current.filter(Boolean);
        if (targets.length === 0) return;

        const ctx = gsap.context(() => {
            gsap.set(targets, { color: UNFILLED });
            // Scrub the word fill across the natural scroll of the section.
            // The text passes through the viewport while the hero marquee
            // stays peeking above and the playbook starts to peek below.
            gsap.to(targets, {
                color: FILLED,
                ease: "none",
                stagger: { each: 1, from: "start" },
                scrollTrigger: {
                    trigger: textEl,
                    start: "top 70%",
                    end: "bottom 30%",
                    scrub: 0.4,
                    invalidateOnRefresh: true,
                },
            });
        }, section);

        return () => ctx.revert();
    }, []);

    return (
        <section
            id="fill-copy"
            data-testid="fill-copy-section"
            ref={sectionRef}
            className="relative bg-background py-32 md:py-48"
        >
            <div className="relative w-full flex items-center justify-center px-6 md:px-12">
                <p
                    ref={textRef}
                    data-testid="fill-copy-text"
                    className="text-center"
                    style={{
                        maxWidth: "1200px",
                        fontFamily:
                            '"DIN Alternate", "DIN Alternate Bold", "Figtree", "Inter", system-ui, sans-serif',
                        fontWeight: 700,
                        fontSize: "clamp(1.75rem, 3.6vw, 4rem)",
                        lineHeight: 1.15,
                        letterSpacing: "-0.01em",
                        color: UNFILLED,
                        textTransform: "none",
                    }}
                >
                    {words.map((w, i) => (
                        <span
                            key={i}
                            ref={(el) => (wordsRef.current[i] = el)}
                            style={{
                                color: UNFILLED,
                                transition: "color 0s",
                            }}
                            data-testid={`fill-word-${i}`}
                        >
                            {w}
                            {i < words.length - 1 ? " " : ""}
                        </span>
                    ))}
                </p>
            </div>
        </section>
    );
}
